import { Component } from '@angular/core';

@Component({
    selector: 'app-admin-home-projects',
    templateUrl: './admin-home-projects.component.html',
    styleUrls: ['./admin-home-projects.component.sass'],
    standalone: false
})
export class AdminHomeProjectsComponent {
}
